import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { DashboardArea } from "../../../models/roles";
import { MenuMainNode } from "./nodes";

export function entityKeyResolver<T extends DashboardArea>(name: Extract<keyof T, string>): string { return name; };

export const dashboardMenu: MenuMainNode = {
  icon: 'dashboardIconTemplate',
  title: 'Menu.Dashboard.Name',
  rootPath: '/dashboard',
  areaPermissionKey: permissionAreaKeyNameOf('dashboard'),
  children: [
    {
      title: 'Menu.Dashboard.InnerDashboard.Name',
      abbreviation: 'Menu.Dashboard.InnerDashboard.Abbreviation',
      link: '/dashboard',
      ignorePermissions: true
    },
    // Work Queues moved to Root Menu Level
  ]
};
